import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { navigateTo } from '@makemydeal/dr-activities-common';
import { setActiveSection, setHamburgerVisibility } from '@makemydeal/dr-sales-checkin-store';
import { TAKEOVER_ROUTES, type TakeoverSectionKey } from '@makemydeal/dr-sales-checkin-types';

export const useOpenTakeover = () => {
    const dispatch = useDispatch();

    return useCallback(
        (sectionKey: TakeoverSectionKey) => {
            // Recorded here rather than from the address, because the section whose action was used
            // is not always the highlighted one: the activation line sits at 30% of the viewport, so
            // a short entry section can be on screen while its neighbour holds the highlight.
            dispatch(setActiveSection(sectionKey));
            dispatch(setHamburgerVisibility(false));
            dispatch(navigateTo(TAKEOVER_ROUTES[sectionKey]));
        },
        [dispatch]
    );
};
